import React from 'react';
import { Resource, WithPermissions } from 'react-admin';

const ResourceWithAuthorization = props => (
  <WithPermissions
    render={({ permissions }) => permissions && <Resource {...props} />}
  />
);

export default ResourceWithAuthorization;